import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";

const services = [
  {
    to: "/instantconsultation",
    icon: "fa-bolt",
    title: "Instant Consultation",
    desc: "Talk to a doctor right away — no waiting.",
    gradient: "var(--gradient-card-2)",
    glow: "rgba(26, 122, 130, 0.22)",
  },
  {
    to: "/bookingconsultation",
    icon: "fa-calendar",
    title: "Book Appointment",
    desc: "Schedule visits with specialists at your preferred time.",
    gradient: "var(--gradient-card-1)",
    glow: "rgba(13, 92, 99, 0.22)",
  },
  {
    to: "/selfcheckup",
    icon: "fa-heartbeat",
    title: "Self Checkup",
    desc: "Quick health assessments and symptom guidance.",
    gradient: "var(--gradient-card-3)",
    glow: "rgba(154, 107, 79, 0.22)",
  },
  {
    to: "/healthblog",
    icon: "fa-file-text-o",
    title: "Health Blog",
    desc: "Tips, articles, and wellness guidance from experts.",
    gradient: "var(--gradient-card-4)",
    glow: "rgba(61, 139, 122, 0.22)",
  },
];

const Home = () => {
  return (
    <div className="home-page">
      <div className="home-hero-banner">
        <h1>How can we <span className="text-gradient">help you</span> today?</h1>
        <p>Pick a service and get started in seconds.</p>
      </div>
      <div className="home-grid">
        {services.map((s) => (
          <Link key={s.to} to={s.to} className="home-card" style={{ "--card-glow": s.glow }}>
            <div className="home-card__icon" style={{ background: s.gradient }}>
              <i className={`fa ${s.icon}`} />
            </div>
            <h3>{s.title}</h3>
            <p>{s.desc}</p>
            <span className="home-card__link">
              Get started <i className="fa fa-arrow-right" />
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Home;
